import { EllipsisVerticalIcon, PencilIcon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'
import { ModalTitle } from '@/shared/components/ui/modal'
import { Separator } from '@/shared/components/ui/separator'

import { EditAnchorStrategyNameTrigger } from './EditAnchorStrategyNameTrigger'

export function StrategyHeader() {
	const { t } = useTranslation()

	const { watch, setValue } = useFormContext()
	const nameWatcher = watch('name')
	const scope = {
		value: nameWatcher,
		onChange: (value: string) =>
			setValue('name', value, {
				shouldDirty: true,
			}),
	}

	return (
		<div className='flex w-full items-center justify-between'>
			<ModalTitle>{nameWatcher}</ModalTitle>
			<div className='mr-6 flex items-center gap-2'>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button
							data-testid='strategy-modal-actions-trigger'
							variant='ghost'
							size='icon-sm'
						>
							<EllipsisVerticalIcon />
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent align='end'>
						<EditAnchorStrategyNameTrigger scope={scope}>
							<DropdownMenuItem>
								<PencilIcon /> {t('app.edit_name')}
							</DropdownMenuItem>
						</EditAnchorStrategyNameTrigger>
					</DropdownMenuContent>
				</DropdownMenu>
				<Separator orientation='vertical' className='mr-2 h-6!' />
			</div>
		</div>
	)
}
